import { queryToObject } from "utils";

// Sync dynamic URL params with pagination links to preserve URL state.
export default function PaginationSync(syncParams = []) {
  if (!syncParams || !syncParams.length) {
    throw new Error("PaginationSyncError: syncParams are required");
  }

  document.addEventListener("click", (event) => {
    if (event.target.matches("a.pagenav")) {
      event.preventDefault();

      const url = new URL(event.target.href);
      const params = queryToObject(window.location.search);

      window.location.href = syncParams.reduce((acc, key) => {
        const value = params[key];
        value !== undefined && value !== null
          ? acc.searchParams.set(key, value)
          : acc.searchParams.delete(key);
        return acc;
      }, url);
    }
  });
}
